import { render, staticRenderFns } from "./WebOrder.vue?vue&type=template&id=774c2c41&scoped=true"
import script from "./WebOrder.vue?vue&type=script&lang=js"
export * from "./WebOrder.vue?vue&type=script&lang=js"
import style0 from "./WebOrder.vue?vue&type=style&index=0&id=774c2c41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774c2c41",
  null
  
)

export default component.exports